import _ from 'lodash';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Segment } from 'semantic-ui-react';
import { SettingParentContext } from '../../cnr/contexts/SettingParentContext';
import { SettingsAreaContext } from '../../cnr/contexts/SettingsAreaContext';
import { settingsActionReducer, settingsActionsHandlers, settingsActionsInitialState } from '../../cnr/reducers/SettingsActionsReducer';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import { HelpDoc } from '../../components/help/HelpDoc';
import JsonViewer from '../../components/viewers/JsonViewer';
import { gEnums } from '../../enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import { actionButtonsTypes, fetchButton_via, getAppAreaActionButtons } from '../actions/buttons/actionButtons';
import SettingsViewer from '../actions/SettingsViewer';
import CreateSomething from '../create/CreateSomething';
import { settingsActionTypes } from '../enums/itemActionTypes';
import DeleteClient from '../events/DeleteClient';
import DeleteEvent from '../events/DeleteEvent';
import { PushToProduction } from '../events/PushToProduction';
import { UpdateEventStatus } from '../events/UpdateEventStatus';
import AppFormsViewer from './AppFormsViewer';
import BaseSettingsViewer from './BaseSettingsViewer';
import JsonPasteSettings from './JsonPasteSettings';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares ';

/**
* Returns a component for handling actions
* @param {props} props (isGlobal, viType)
* @returns a component for handling actions
* @calledFrom ViewSettingsComponent
* @for case gEnums.viewSettingTypes.appActions:
* @for case gEnums.viewSettingTypes.googleActions:
* @for case gEnums.viewSettingTypes.settingsActions:
* @for case gEnums.viewSettingTypes.viewActions:
*/
const SettingsActionItems = (props) => {

  const { isGlobal, viType } = props

  const parentContext = useContext(ParentContext)
  const { fn_cls } = parentContext ?? {}
  const mainStorage = _.get(parentContext, 'states.app_state.mainStorage')

  // settingsParentContext
  const settingsParentContext = useContext(SettingParentContext)
  const { states, fns, settings } = settingsParentContext ?? {}

  const { appUser_state, paps_state, page_state, currentSettings_state } = states ?? {}
  const { page_fns, database_fns, appSettings_fns } = fns ?? {}

  const { aps_global, aps_viewItems, aps_views, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  const { homeSettings } = settings ?? {}
  const { global: global_home } = homeSettings ?? {}
  const { logging } = global_home ?? {}

  const { settingsPermissions } = global_home ?? {}
  let { allowResetSettings, allowCopySettings } = settingsPermissions ?? {}

  // authContext 
  const { appUser } = appUser_state ?? {}

  // papsContext 
  const { appArea } = paps_state ?? {}

  // settingsAreaContext
  const settingsAreaContext = useContext(SettingsAreaContext);

  allowResetSettings = true

  // parentContext, componentContexts
  const initState = { fn_cls, database_fns, appSettings_fns, mainStorage, settingsParentContext, settingsAreaContext, logging }
  const [settingsActions_state, settingsAction_dispatch] = useReducer(settingsActionReducer, initState, settingsActionsInitialState);
  const settingsActions_handlers = settingsActionsHandlers(settingsAction_dispatch, settingsActions_state, true)

  const { handleCommitViewSettingsAction, handlePreviewAction, handlePreviewReady, handleConfirmClose, handleKillPreview } = settingsActions_handlers ?? {}
  const { confirmation, previewInfo, previewClicked, updating, updatingCaption } = settingsActions_state

  const [showItemHelp, setShowItemHelp] = useState();
  const [createInfo, setCreateInfo] = useState();
  const [actionButtons, setActionButtons] = useState([])
  const [actionButtonz, setActionButtonz] = useState([])
  const [fbProps, setFbProps] = useState();


  console.log('actionButtonz', actionButtonz)
  console.log('actionButtons', actionButtons)

  const handle_actionButtons = (abs, abss) => {
    setActionButtons(abs, abss)
    setActionButtonz(abss)
  }

  // a different set of menuItems depending on the viType
  useEffect(() => {
    const _fbProps = {
      allowCopySettings,
      allowResetSettings,
      appArea,
      confirmation,
      handleItemHelp,
      handlePreviewClicked,
      isGlobal,
      previewClicked,
      previewInfo,
      reset,
      viType,
    }
    // get the list of all the menu buttons for the current appArea
    getAppAreaActionButtons(viType, _fbProps, handle_actionButtons)
    setFbProps(_fbProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpdateParent = () => { console.log('handleUpdateParent') }
  const handleCreateInfo = (ci) => setCreateInfo(ci)

  /** triggers the diplay for the data that will be committed */
  const handlePreviewClicked = (actionName) => {
    console.log('actionName', actionName)
    const previewProps = {
      actionName,
      appUser,
      homeSettings_global: global_home,
      aps_global,
      aps_viewItems,
      aps_views,
      page_fns,
      paps_state,
      previewInfo,
      database_fns,
      fn_cls,
    }
    handlePreviewAction(actionName, previewProps)
  }

  /** triggers commit of the data */
  const handleConfirmClicked = (bc, opts) => {

    let _actionName;
    let optz;

    if (_.isObject(bc)) {
      _actionName = bc.previewClicked
      optz = { ...bc }
    } else {
      _actionName = bc
    }

    const commitProps = {
      appUser,
      actionName: _actionName,
      aps_global,
      aps_viewItems,
      aps_views,
      createInfo,
      homeSettings_global: global_home,
      opts,
      page_fns,
      paps_state,
      previewInfo,
      optz
    }

    // settingsActions_handlers
    handleCommitViewSettingsAction(commitProps)

  }

  const handleItemHelp = () => setShowItemHelp(!showItemHelp)

  const reset = () => {
    handleKillPreview()
    handleConfirmClose()
    handlePreviewClicked()
  }

  const previewContent = () => {

    switch (previewClicked) {

      case settingsActionTypes.createClient:
      case settingsActionTypes.createEvent:
      case settingsActionTypes.copyEvent:
        return <CreateSomething
          createOrigin={gEnums.createOriginTypes.viewSettings}
          createType={previewClicked}
          createVit={'clients'}
          handleCreateInfo={handleCreateInfo}
          updateParent={handleUpdateParent}
        />

      case settingsActionTypes.createHelpDocument:
        return <HelpDoc />

      case settingsActionTypes.deleteClient:
        return <DeleteClient />

      case settingsActionTypes.deleteEvent:
        return <DeleteEvent handleClick={handleCommitViewSettingsAction} />

      case settingsActionTypes.updateEventStatus:
        return <UpdateEventStatus handleConfirmClicked={handleConfirmClicked} settingsActionType={previewClicked} />

      case settingsActionTypes.pushClientToProduction:
        return <PushToProduction />

      case settingsActionTypes.restoreSettingsFromPaste:
        return <JsonPasteSettings isGlobal={isGlobal} handlePreviewReady={handlePreviewReady} showButtons={{ 'paste': true }} />

      case settingsActionTypes.currentSettings:
        const settingsJson = isGlobal ? { aps_global, aps_viewItems, aps_views } : { ...aps_page }
        const settingsName = isGlobal ? 'settings' : 'pageSettings'
        return <JsonViewer json={settingsJson} name={settingsName} isGlobal={isGlobal} showButtons={{ 'copy': true }} />

      case settingsActionTypes.baseForms:
        return <AppFormsViewer />

      case settingsActionTypes.baseSettings:
        return <BaseSettingsViewer />

      case settingsActionTypes.duplicateGoogleSheets:
      case settingsActionTypes.pushEventToProduction:
      case settingsActionTypes.restoreSettingsFromBackup:
      case settingsActionTypes.restoreSettingsFromRegistration:
      case settingsActionTypes.transferDataToProduction:
      case settingsActionTypes.transferEventToProduction:
      case settingsActionTypes.transferSettingsToProduction:
      case settingsActionTypes.updateDataFromGoogleData:
      case settingsActionTypes.updateDataFromGoogleSheets:
      case settingsActionTypes.updateSettingsFromGoogleSheets:
        if (previewInfo) {
          if (_.isObject(previewInfo)) {
            return <SettingsViewer actionName={previewClicked} viewItemDataActions_state={settingsActions_state} viewItemDataActions_handlers={settingsActions_handlers} createType={'updateEvent'} createInfo={previewInfo} handleConfirmClicked={handleConfirmClicked} />
          } else {
            return <Segment basic inverted>{_.startCase(previewInfo)}</Segment>
          }
        }
        if (confirmation) { return <Segment inverted>{confirmation.title}</Segment> }
        break;

      default:
        return previewInfo ? <JsonViewer name='preview' json={previewInfo} /> : <div>{previewClicked}</div>
    }
  }

  const footer = () => {
    switch (previewClicked) {
      case settingsActionTypes.backupData:
      case settingsActionTypes.backupSettings:
      case settingsActionTypes.deleteBucket:
      case settingsActionTypes.fixAllSettings:
      case settingsActionTypes.fixSettings:
      case settingsActionTypes.restoreSettingsFromPaste:
      case settingsActionTypes.transferDataToProduction:
      case settingsActionTypes.transferSettings:
      case settingsActionTypes.transferSettingsToProduction:
        return <UiSaveButtons save={{ oc: handleConfirmClicked, caption: _.startCase(previewClicked), disabled: !previewInfo, opts: { previewClicked } }} />

      case settingsActionTypes.convertSettingsToSeparate:
        return <UiSaveButtons
          save={{ oc: handleConfirmClicked, caption: _.startCase(previewClicked), disabled: !previewInfo, opts: { previewClicked } }}
          preview={{ oc: handleConfirmClicked, caption: _.startCase(previewClicked) + ' No Merge', disabled: !previewInfo, opts: { previewClicked, noMerge: true } }}
        />

      case settingsActionTypes.transferEventToProduction:
        return <UiSaveButtons
          save={{ oc: handleConfirmClicked, caption: _.startCase(previewClicked), disabled: !previewInfo, opts: { previewClicked } }}
          preview={{ oc: handleConfirmClicked, caption: _.startCase(previewClicked) + ' NCS', disabled: !previewInfo, icon: 'save', opts: { previewClicked, noClientSettings: true } }}
        />
      default:
      // nothing
    }
  }

  const wbSquares = () => {
    return _.map(actionButtonz, a => {
      return <ItemMenuSquares
        menuItems={a.items}
        imsType={_imsTypes.inline}
        caption={a.caption}
        icon={'options'}
        onClick={handlePreviewClicked}
      />
    })
  }

  const wrapperButtons = (cn) => <Wrapper
    // content={<ItemMenuSquares menuItems={actionButtonsTypes.baseSettings} imsType={_imsTypes.inline} />}
    content={wbSquares()}
    // content={actionButtons && actionButtons}
    wrapperType={wrapperTypes.paddedContent}
    updating={updating}
    updatingCaption={updatingCaption}
    confirmation={confirmation}
  />

  const wrapperPreview = (cn) => <Wrapper
    // header={fetchButton_via(fbProps, previewClicked)}
    content={previewContent()}
    footer={footer()}
    wrapperType={wrapperTypes.paddedFooter}
    updating={updating}
    updatingCaption={updatingCaption}
    confirmation={confirmation}
  />

  return previewClicked ? wrapperPreview() : wrapperButtons()
}

export default SettingsActionItems